import { render, staticRenderFns } from "./BeyondPage.vue?vue&type=template&id=32a93490&scoped=true&"
import script from "./BeyondPage.vue?vue&type=script&lang=js&"
export * from "./BeyondPage.vue?vue&type=script&lang=js&"
import style0 from "./BeyondPage.vue?vue&type=style&index=0&id=32a93490&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a93490",
  null
  
)

export default component.exports